document.addEventListener('DOMContentLoaded', function() {
    let radioType = document.querySelectorAll('.subscribe_and_save-section input[name="purchase_option"]'),
    variantSelector = document.querySelectorAll('ul.select-buttons.js_selectButtons li[data-variant-option-set-position]'),
    sellingPlanSelector = document.querySelectorAll('div[selling-plan-selector]'),
    btnSubscription = document.querySelectorAll('button[name="add"].subscription'),
    btnOneTime = document.querySelectorAll('button[name="add"][one-time]');
    console.log('radios', radioType)
    if(radioType.length > 0) {
      radioType.forEach((radio) => {
        radio.addEventListener('change', (e) => {
          console.log('cambiado')
          let self = e.currentTarget,
          type = self.getAttribute('class'),
          sellingPlanSelectOptions = document.querySelectorAll('input[name="selling_plan"].pdp-initial'),
          oneTimeVariants = document.querySelectorAll('ul.select-buttons.js_selectButtons li[data-variant-option-set-position][type="one-time"]');
          radioType.forEach((_radio) => {
            _radio.removeAttribute('checked')
          });
          self.setAttribute('checked', 'checked');
          console.log('tipo', type);
          if(type == 'one-time-input') {
            document.querySelector('div[type="one-time"]').classList.add('is-active');
            document.querySelector('div[type="subscribe"]').classList.remove('is-active');
            if(sellingPlanSelectOptions.length > 0) {
              sellingPlanSelectOptions[0].setAttribute('value', '');
              sellingPlanSelectOptions[0].value = '';
              if(sellingPlanSelector.length > 0) {
                sellingPlanSelector.forEach((plan) => {
                  plan.classList.remove('smartrr-plan-active');
                });
              }
            }
  
            if(oneTimeVariants.length > 0) {
              oneTimeVariants[0].click();
            }
  
            document.querySelector('div[price-subscribe]').innerHTML = '';
          } else {
            document.querySelector('div[type="subscribe"]').classList.add('is-active');
            document.querySelector('div[type="one-time"]').classList.remove('is-active');
  
            btnSubscription[0].setAttribute('disabled', 'disabled');
  
            document.querySelector('.subscribe_and_save-section input[name="quantity"]').value = 1;
            document.querySelector('.subscribe_and_save-section input[name="quantity"]').setAttribute('value', 1);
  
            if(variantSelector.length > 0) {
              variantSelector.forEach((variant) => {
                if(variant.classList.contains('selected') && variant.getAttribute('type') == 'subscription') {
                  let priceSelected = variant.getAttribute('price'),
                  compareAtPriceSelected = variant.getAttribute('compare-at-price');
  
                  document.querySelector('div[price-one-time]').innerHTML = '';
                  document.querySelector('div[price-subscribe]').innerHTML = `${priceSelected} <del style="color:grey"><span>${compareAtPriceSelected}</span></del>`;
                }
              });
            }
  
            if(document.querySelectorAll('ul.select-buttons.js_selectButtons li[data-variant-option-set-position][type="subscription"]').length > 0) {
              document.querySelectorAll('ul.select-buttons.js_selectButtons li[data-variant-option-set-position][type="subscription"]')[0].click();
            }
          }
        });
      });
    }
  
    if(variantSelector.length > 0) {
      variantSelector.forEach((variant) => {
        variant.addEventListener('click', (e) => {
          e.preventDefault();
          let self = e.currentTarget,
          id = self.getAttribute('data-variant-id'),
          type = self.getAttribute('type'),
          variantSelectOptions = document.querySelectorAll('.subscribe_and_save-section .js_productSelect.selector-wrapper[name="id"] option');
          let variantTitle = self.getAttribute('data-variant-name') || '';
          let priceString = self.getAttribute('price') || '';
          let comparePriceString = self.getAttribute('compare-at-price') || '';

          let quantityMatch = variantTitle.match(/\d+/);
          let quantity = quantityMatch ? parseInt(quantityMatch[0]) : 1;

          let price = parseFloat(priceString.replace(/[^0-9.]/g, ''));
          if (isNaN(price) || price <= 0) {
            price = 0;
          }

          let comparePrice = parseFloat(comparePriceString.replace(/[^0-9.]/g, ''));
          if (isNaN(comparePrice) || comparePrice <= 0) {
            comparePrice = 0;
          }

          let unitMatch = variantTitle.match(/\d+\s*(\w+)/i);
          let unit = unitMatch ? unitMatch[1] : 'unidad';
          if(unit.endsWith('s') && unit.length > 1) {
            unit = unit.slice(0, -1);
          }

          let pricePerUnit = quantity > 0 ? (price / quantity).toFixed(2) : '0.00';
          let breakdownText = (price > 0 && unit) ? `$${pricePerUnit}/${unit}` : '';

          let comparePricePerUnit = quantity > 0 ? (comparePrice / quantity).toFixed(2) : '0.00';
          let compareBreakdownText = (comparePrice > 0 && unit) ? `$${comparePricePerUnit}/${unit}` : '';

          variantSelector.forEach((_variant) => {
            _variant.classList.remove('selected');
          });
          self.classList.add('selected');
  
          if(variantSelectOptions.length > 0) {
            variantSelectOptions.forEach((option) => {
              if(option.getAttribute('value') == id) {
                option.setAttribute('selected', 'selected');
              } else {
                option.removeAttribute('selected');
              }
            });
          }
  
          if(type == 'subscription') {
            document.querySelector('div[price-one-time]').innerHTML = '';
            document.querySelector('div[data-subscribe_and_save-breakdown]').innerHTML =  `<del style="color:grey"><span>${self.getAttribute('compare-at-price')} (${compareBreakdownText})</span></del>`;
            document.querySelector('div[data-one-time-purchase-breakdown]').innerHTML = '';
            document.querySelector('div[price-subscribe]').innerHTML = `${self.getAttribute('price')} (${breakdownText})`;
  
            if(document.querySelectorAll('div[selling-plan-selector].smartrr-plan-active').length > 0) {
              btnSubscription[0].removeAttribute('disabled');
            }
  
          } else {
            document.querySelector('div[price-subscribe]').innerHTML = '';
            document.querySelector('div[price-one-time]').innerHTML = `${self.getAttribute('price')} (${breakdownText})`;
            document.querySelector('div[data-one-time-purchase-breakdown]').innerHTML = '';
            document.querySelector('div[data-subscribe_and_save-breakdown]').innerHTML = '';
  
            btnOneTime[0].removeAttribute('disabled');
          }
  
          document.querySelector('input[name="id"].form-pdp').setAttribute('value', id)
          document.querySelector('input[name="id"].form-pdp').value = id;
        });
  
        //onload
        let subscribeInputs = document.querySelector('input[name="purchase_option"][checked]');
        if(subscribeInputs.classList.contains('subscribe-input')) {
          if(variantSelector[0].getAttribute('type') == 'subscription') {
            variantSelector[0].click();
          }
        }
      });
    }
  
    if(sellingPlanSelector.length > 0) {
      sellingPlanSelector.forEach((plan) => {
        plan.addEventListener('click', (e) => {
          e.preventDefault();
          let self = e.currentTarget,
          id = self.getAttribute('data-smartrr-selling-plan-button'),
          sellingPlanSelectOptions = document.querySelectorAll('input[name="selling_plan"].pdp-initial'),
          variantsSubscription = document.querySelectorAll('.subscribe_and_save-section[type="subscribe"] ul.select-buttons.js_selectButtons li[data-variant-option-set-position].selected');
          sellingPlanSelector.forEach((_plan) => {
            _plan.classList.remove('smartrr-plan-active');
          });
          self.classList.add('smartrr-plan-active');
  
          sellingPlanSelectOptions[0].setAttribute('value', id);
          sellingPlanSelectOptions[0].value = id;
  
          if(variantsSubscription.length > 0) {
            btnSubscription[0].removeAttribute('disabled');
          }
        });
      });
    }
  
    if(btnSubscription.length > 0) {
      btnSubscription.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          let btnPlanDays = document.querySelectorAll('div[selling-plan-selector].smartrr-plan-active'),
          variantsSubscription = document.querySelectorAll('.subscribe_and_save-section[type="subscribe"] ul.select-buttons.js_selectButtons li[data-variant-option-set-position].selected');
  
          if(btnPlanDays.length == 0 && variantsSubscription.length == 0) {
            alert('Please select a package size and a subscription plan');
          } else {
            e.currentTarget.removeAttribute('disabled');
          }
        });
      });
    }

    // Dropdown functionality
    const dropdowns = document.querySelectorAll('.item_dropdown');
    dropdowns.forEach(dropdown => {
      const title = dropdown.querySelector('.tlt');
      const content = dropdown.querySelector('.dropdown_content');
      
      title.addEventListener('click', () => {
        // Toggle active class on the dropdown
        dropdown.classList.toggle('active');
        
        // Toggle the content visibility
        if (content.style.maxHeight) {
          content.style.maxHeight = null;
        } else {
          content.style.maxHeight = content.scrollHeight + "px";
        }
      });
    });
  });